import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import workloadDurationByHoursChart from './workload-duration-by-hours-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-duration-by-hours-chart-controller',
  setup(__props) {

const dashboardChartUtils = useDashboardChartUtils();

const workloadDurationByHoursChartConfig = useDashboard().workloads.workloadDurationByHoursChart;
const options = computed(() => ({
  ...workloadDurationByHoursChartConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: workloadDurationByHoursChartConfig as any,
        chartId: workloadDurationByHoursChartConfig.value.chartId,
        componentInstance: workloadDurationByHoursChart,
      }),
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(workloadDurationByHoursChart, {
    "chart-options": { ..._unref(workloadDurationByHoursChartConfig), options: _unref(options) }
  }, null, 8, ["chart-options"]))
}
}

})